// extracted by mini-css-extract-plugin
export default {"container":"styles_container__VrPYF","innerContainer":"styles_innerContainer__FgKck","input":"styles_input__h1JHk","buttonsContainer":"styles_buttonsContainer__tK0Re"};